import Vue from 'vue';
import BackendService from './BackendService'
import store from '@/store'
import algoliasearch from 'algoliasearch'

export default class SearchService extends BackendService {

  private ALGOLIA_APP_ID = '2Z1D7FMA14';

  async querySearch(indice: string, query: string) {

    const searchKey = store.state.user.searchKey;
    if (!searchKey || searchKey === '') {
      await this.getSearchKey();
    }

    // Data will contain the restricted key in the `key` field.
    const client = algoliasearch(this.ALGOLIA_APP_ID, store.state.user.searchKey);
    const index = client.initIndex(indice);

    return await index.search(query)
      .then((res) => {
        return res.hits;
      })
      .catch((error) => {
        console.log('Error in querySearch: ', error);
      })
  }

  async getSearchKey() {
    const token = store.state.user.firebaseToken;

    if (!token) {
      throw Error('No firebase token, cant get search key');
    }

    return await fetch('https://europe-west1-apif-prod.cloudfunctions.net/getSearchKey',
      {
        headers: { Authorization: 'Bearer ' + token }
      })
      .then(async (response) => {
        // The Fetch API returns a stream, which we convert into a JSON object.
        return await response.json();
      })
      .then(async (data) => {
        return await store.dispatch('user/setSearchKey', data.key);
      })
  }
}